/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import "../../css/pages/home.css";
import "../../css/pages/customers.css";
import { Link } from "react-router-dom";
import undrawSearch from "../../assets/svgs/undraw_search_re_ttoj.svg";
import SideNav from "../components/SideNav";
import TopNav from "../components/TopNav";
import {
  fetchLoans,
  fetchInsuranceBusinesses,
  fetchInsuranceStats,
} from "../actions/p2p";
import Pagination from "../components/Pagination";
import NoData from "../../assets/svgs/undraw_No_data_re_kwbl.svg";
// import MoreToggle from "../components/MoreToggle";
import { fillUser } from "../actions/account";

class Loans extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loans: [],
      loan_arr: [],
      selected_loans: {},
      query: "",
      current_page: new URLSearchParams(props.location.search).get("page") || 1,
      status_id:
        new URLSearchParams(props.location.search).get("status_id") || "",
      limit: 10,
      create: false,
      edit: false,
      cancel: false,
      single: false,
      multiple: false,
    };
  }

  componentDidMount() {
    try {
      fetchInsuranceStats()
        .then(({ data }) => {
          console.log({ data }, "vvvv");
          this.setState({
            insuranceStats: data,
          });
        })
        .catch(() =>
          toast.error(
            "An error occured fetching insurance stats on your account."
          )
        );
    } catch (error) {
      console.log(error);
    }
  }

  handlePageChange= (data) => {
    const { limit, query } = this.state;
    fetchInsuranceBusinesses(
      data.currentPage,
      query,
      "created_on",
      "DESC",
      limit,
    ).then(({ data: { groups, page_info } }) => {
      console.log(data, "bbbbb");
      //
      this.setState({
        groups,
        current_page: page_info.page,
        total: page_info.total,
      });
    });
  };

  // handlePageChange = (data) => {
  //   const { limit, query } = this.state;
  //   fetchLoans(
  //     data.currentPage,
  //     query,
  //     "disbursed_on",
  //     "DESC",
  //     limit,
  //     "",
  //     "",
  //     "",
  //     this.state.status_id
  //   ).then(({ data: { loans, page_info } }) =>
  //     this.setState({
  //       loans,
  //       current_page: page_info.page,
  //       total: page_info.total,
  //     })
  //   );
  // };

  fetchNextDueDate = (schedules) => {
    schedules = schedules.filter((schedule) => {
      const start = moment(new Date());
      const end = moment(new Date(schedule?.due_date));
      const duration = moment.duration(end.diff(start));
      if (duration.asMinutes() >= 0) {
        return true;
      }
      return false;
    });
    if (schedules.length > 0) {
      return schedules[0].due_date;
    }
    return "-";
  };

  onSearch = (e) => {
    const { limit } = this.state;
    this.setState({ query: e.currentTarget.value });
    fetchInsuranceBusinesses(
      e.currentPage,
      e.currentTarget.value,
      "created_on",
      "DESC",
      limit,
    ).then(({ data: { groups, page_info } }) => {
      this.setState({
        groups,
        current_page: page_info.page,
        total: page_info.total,
      });
    });
  };

  render() {
    const {
      loans,
      selected_loans,
      loan_arr,
      action,
      loading,
      loan,
      total,
      current_page,
      limit,
      create,
      edit,
      cancel,
      single,
      multiple,
      stats,
      total_loans,
      insuranceStats,
      groups,
    } = this.state;

    console.log({ insuranceStats, groups });

    const { history, user } = this.props;
    return (
      <>
        <SideNav page="insurance" />
        <main className="body-main">
          <div className="body-main__container">
            <TopNav page="insurance" />
            <div className="default-card home__stats">
              <div className="row">
                <Link
                  style={{ textDecoration: "none", cursor: "pointer" }}
                  className="col-12 col-md-4 home__stats--group"
                >
                  <div className="home__stats--group-content">
                    <p>PREMIUM PAID COUNT</p>
                    <h3>{Number(insuranceStats?.[0]?.premium_paid_count)||null}</h3>
                  </div>
                </Link>
                <Link
                  style={{ textDecoration: "none", cursor: "pointer" }}
                  className="col-12 col-md-4 home__stats--group"
                >
                  <div className="home__stats--group-content">
                    <p>PREMIUM PAID SUM</p>
                    <h3>{Number(insuranceStats?.[0]?.premium_paid_sum)||null}</h3>
                  </div>
                </Link>
                <Link
                  style={{ textDecoration: "none", cursor: "pointer" }}
                  className="col-12 col-md-4 home__stats--group"
                >
                  <div className="home__stats--group-content">
                    <p className="no-wrap">PREMIUM PENDING&nbsp;COUNT</p>
                    <h3>
                      {Number(insuranceStats?.[0]?.premium_pending_count)||null}
                    </h3>
                  </div>
                </Link>
              </div>
            </div>
            <div className="row">
              <div className="col">
                {!groups?.length && (
                  <div
                    className="empty-state empty-state-loans"
                    hidden={groups?.length}
                  >
                    <img src={NoData} alt="Illustration for empty state" />
                    <h3 className="empty-state__title">
                      There are no insurance yet.
                    </h3>
                    {/* <p className="empty-state__subtext">
                      Insurance will show up here once you start lending.
                    </p> */}
                
                  </div>
                )}
                <div className="filled--state loans" hidden={!groups?.length}>
                  <div className="filter-and-search">
                    <div className="filter-box d-flex">
                  
                      <div className="search-box">
                        <input
                          type="search"
                          className="form-control"
                          placeholder="Search..."
                          onInput={(e) =>
                            e.currentTarget.value === "" && this.onSearch(e)
                          }
                          onKeyDown={(e) =>
                            e.key === "Enter" && this.onSearch(e)
                          }
                        />
                      </div>
                    </div>
                    <div className="filter-and-search d-flex justify-content-end">
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <div className="card default-card page-table">
                        <div className="empty-state no-result" hidden>
                          <img
                            src={undrawSearch}
                            alt="Illustration for search"
                          />
                          <h3 className="empty-state__title">
                            No results found.
                          </h3>
                          <p className="empty-state__subtext">
                            Please check your spelling or try searching for
                            something different.
                          </p>
                        </div>

                        <div className="table-responsive">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th className="borrower_id">User ID</th>
                                <th className="name">Nickname</th>
                                <th className="loan_amount">Product</th>
                                <th className="amount_paid">Total Members</th>
                                <th className="amount_due">Total Assets</th>
                                <th className="status">Status</th>
                                <th className="date-time">Date Created</th>
                              </tr>
                            </thead>
                            <tbody>
                              {groups?.map((item) => (
                                <tr
                                  key={item?.id}
                                  role="button"
                                  onClick={() =>
                                    history.push(`insurance/${item.id}`)
                                  }
                                >
                                  <td
                                    className="select_loan text-nowrap"
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    {item?.user_id}
                                  </td>
                                  <td className="borrower_id text-nowrap">
                                    {item?.nickname}
                                  </td>
                                  <td className="name text-nowrap">
                                    {item?.product?.name}
                                  </td>
                                  <td className="loan_amount text-nowrap text-center">
                                    {Number(item?.total_members)}
                                  </td>
                                  <td className="amount_paid text-nowrap text-center">
                                    {Number(item?.total_assets)}
                                  </td>
                                  <td className="interest_rate text-nowrap">
                                    {item?.status}
                                  </td>

                                  <td className="date-time text-nowrap">
                                    <span className="date">
                                      {moment(item?.created_on).format(
                                        "MMM DD, YYYY, h:mm:ss a"
                                      )}
                                    </span>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <Pagination
                        totalRecords={total}
                        pageLimit={limit}
                        pageNeighbours={1}
                        onPageChanged={this.handlePageChange}
                        initialPage={current_page}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.account?.user || {},
});

const mapDispatchToProps = { fillUser };

export default connect(mapStateToProps, mapDispatchToProps)(Loans);
